export default {"src":"https://dap-cjx0935f8-dap-rewrite.vercel.app/_next/static/media/notification_icon.762ae837.svg","height":27,"width":28};